import { Placement } from 'react-joyride';
import { BaseTour } from '../BaseTour';

export class ReportsAnalyticsTour extends BaseTour {
  id = 'reports-analytics-chart';

  content = 'Learn how to use Reports & Analytics to understand invoice performance and generate insights';

  // Default placement for tooltips
  placement: Placement = 'bottom';

  steps = {
    reportsAnalyticsPage: () => ({
      content:
        'Welcome to Reports & Analytics --- your data hub for understanding invoice performance, tracking spending, and generating insights. Open a saved report or click Start New to begin.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),

    filterPanel: () => ({
      content:
        'Narrow down your data using filters: Date (year, quarter, month, week, day), Trade Lane, Country/City Hub, Service Provider, Modality, Invoice/Shipment Number, Billing Reference, Leg/Charge Type, and Invoice Status. Click Reset to Default to clear all filters.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),

    metricsPanel: () => ({
      content:
        'These KPI cards show key metrics at a glance. Click Edit Metrics (table mode) to select which metrics to display --- choose up to 4 from: Invoices, Shipments, Charges, CO₂e Emissions, Volume, Chargeable Weight, Gross Weight, and Total Net Deviation Amount. Each metric shows a Total value and a Table Filter value so you can compare the big picture with your current selection. Click a metric card to activate it on the chart.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),

    // Step 4: chart content area — explains chart visualization modes (shown first)
    chartTableToggle: () => ({
      content:
        'In Chart mode, switch between: Trends (metrics over time --- daily, weekly, monthly), Correlations (compare two metrics against each other), Trade Lane (breakdown by shipping routes or countries), and Shipment Details (operational shipment-level data).',
      placement: 'top' as Placement,
      scrollOffset: 50,
    }),

    // Step 5: Chart/Table toggle button area — explains switching between modes
    chartVisualizationTabs: () => ({
      content:
        'Switch between Chart mode and Table mode. Chart mode is best for spotting trends, presentations, and quick visual insights. Table mode is best for finding specific records, exporting data, and detailed analysis.',
      placement: 'top' as Placement,
      disableScrolling: true,
    }),

    // Step 6: Table button — call-to-action to switch to table mode
    clickTableButton: () => ({
      content: 'Click the Table button to explore the data tables. The tour will continue automatically once you switch.',
      placement: 'bottom' as Placement,
      disableScrolling: true,
    }),
  } as const;
}
